<app-section #parentSection
             [formConfig]="formConfig"
             [sectionRef]="section"
             [formGroup]="formGroup"
             [title]="title"
             [key]="key"
             [class]="sectionClass"
             [ngClass]="{'owner-data-section--next': isNext}"
             [verifyDataVisible]="verifyDataVisible"
             [editMode]="true">

    <ng-template #section>

        <app-section-data-presentation *ngIf="previewMode"
                                       [formGroup]="formGroup"
                                       [formConfig]="formConfig"
                                       [parentSection]="parentSection"
                                       [displayedFields]="dataPresentationFields">
        </app-section-data-presentation>

        <div *ngIf="isFieldVisible(consts.PARTY_CODE_TYPE)" class="section__col section__col--1" [ngClass]="{'col-preview-mode': previewMode}">
            <div class="section__field radio--max owner-data__party-type">
                <app-radio *ngIf="!isNext"
                           [bean]="bean"
                           [errorsMap]="formFactoryService.errorsMap"
                           [control]="formGroup.controls[consts.PARTY_CODE_TYPE]"
                           [fieldConfig]="formFactoryService.fieldConfig(consts.PARTY_CODE_TYPE, formConfig)"
                           [context]="formConfig.formKey"
                           [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.PARTY_CODE_TYPE)]"
                           (markAsDirty)="markAsDirty($event)"
                >
                </app-radio>

                <app-button-toggle *ngIf="isNext"
                                   [bean]="bean"
                           [errorsMap]="formFactoryService.errorsMap"
                           [control]="formGroup.controls[consts.PARTY_CODE_TYPE]"
                           [fieldConfig]="formFactoryService.fieldConfig(consts.PARTY_CODE_TYPE, formConfig)"
                           [context]="formConfig.formKey"
                           [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.PARTY_CODE_TYPE)]"
                           (markAsDirty)="markAsDirty($event)"
                >
                </app-button-toggle>
            </div>
        </div>
        <div *ngIf="ownerDataHintVisible"
             class="owner-data__hint">
            <app-hint
                    *ngIf="showInformation"
                    class="personal-data-hint"
                    [content]="'OWNER_DATA_SECTION.hint'"
                    [size]="isMobile ? 'SMALL' : 'NORMAL'"
                    [rounded]="true"
                    [arrowDown]="true">
            </app-hint>
        </div>
        <div class="col owner-data"
             [ngClass]="{
                'col-preview-mode': previewMode
             }">
            <div class="col-50" *ngIf="!previewMode">
                <div class="section__component"
                     *ngIf="!isOrganization && canFieldDisplayed(consts.FIRST_NAME)">
                    <app-text-field
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.FIRST_NAME]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.FIRST_NAME, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.FIRST_NAME)]"
                            (markAsDirty)="markAsDirty($event)"
                    >
                    </app-text-field>
                </div>

                <div class="section__component"
                     *ngIf="!isOrganization && canFieldDisplayed(consts.LAST_NAME)">
                    <app-text-field
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.LAST_NAME]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.LAST_NAME, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.LAST_NAME)]"
                            (markAsDirty)="markAsDirty($event)"
                    >
                    </app-text-field>
                </div>

                <div class="section__component"
                     *ngIf="!isOrganization && canFieldDisplayed(consts.PESEL)">
                    <app-text-field [errorsMap]="formFactoryService.errorsMap"
                                    [control]="formGroup.controls[consts.PESEL]"
                                    [fieldConfig]="formFactoryService.fieldConfig(consts.PESEL, formConfig)"
                                    [context]="formConfig.formKey"
                                    [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.PESEL)]"
                                    (markAsDirty)="markAsDirty($event)"
                    >
                    </app-text-field>
                </div>
            </div>

            <div class="col-50">
                <div *ngIf="canFieldDisplayed(consts.POSTAL_CODE)" class="section__component">
                    <app-text-field [errorsMap]="formFactoryService.errorsMap"
                                    [control]="formGroup.controls[consts.POSTAL_CODE]"
                                    [fieldConfig]="formFactoryService.fieldConfig(consts.POSTAL_CODE, formConfig)"
                                    [context]="formConfig.formKey"
                                    [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.POSTAL_CODE)]"
                                    (markAsDirty)="markAsDirty($event)"
                    >
                    </app-text-field>
                </div>

                <div class="section__component"
                     *ngIf="canFieldDisplayed(consts.MATRIMONIAL_STATUS)">
                    <app-select
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.MATRIMONIAL_STATUS]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.MATRIMONIAL_STATUS, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.MATRIMONIAL_STATUS)]"
                            (markAsDirty)="markAsDirty($event)"
                    >
                    </app-select>
                </div>

                <div class="section__component"
                     *ngIf="isCarOne && !isOrganization && isFieldVisible(consts.DRIVING_LICENSE_ISSUE_YEAR)">
                    <ng-container *ngTemplateOutlet="drivingLicenseIssueYearTemplate"></ng-container>
                </div>

                <div class="section__component"
                     *ngIf="isCarOne && drivingLicenseIssueMonthCollected && !isOrganization && isFieldVisible(consts.DRIVING_LICENSE_ISSUE_MONTH)">
                    <ng-container *ngTemplateOutlet="drivingLicenseIssueMonthTemplate"></ng-container>
                </div>
            </div>

            <div *ngIf="!isCarOne" class="col-50">
                <div class="owner-data__driving-license-row">
                    <div class="section__component"
                         *ngIf="!isOrganization && canFieldDisplayed(consts.DRIVING_LICENSE_ISSUE_YEAR)">
                        <ng-container *ngTemplateOutlet="drivingLicenseIssueYearTemplate"></ng-container>
                    </div>

                    <div class="section__component owner-data__driving-license-row__no-license"
                         *ngIf="noDrivingLicenseVisible">
                        <app-checkbox
                                [errorsMap]="formFactoryService.errorsMap"
                                [control]="formGroup.controls[consts.NO_DRIVING_LICENSE]"
                                [fieldConfig]="formFactoryService.fieldConfig(consts.NO_DRIVING_LICENSE, formConfig)"
                                [context]="formConfig.formKey"
                                [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.NO_DRIVING_LICENSE)]"
                                (markAsDirty)="markAsDirty($event)"
                        >
                        </app-checkbox>
                    </div>
                </div>

                <div class="section__component"
                     *ngIf="drivingLicenseIssueMonthCollected && !isOrganization && canFieldDisplayed(consts.DRIVING_LICENSE_ISSUE_MONTH)">
                    <ng-container *ngTemplateOutlet="drivingLicenseIssueMonthTemplate"></ng-container>
                </div>
            </div>
        </div>

        <div class="col owner-data-section__company-data" [ngClass]="{'col-preview-mode': previewMode}">

            <div class="section__component col-50"
                 *ngIf="!isNaturalPerson && isFieldVisible(consts.COMPANY_NAME)">
                <app-text-field
                        [errorsMap]="formFactoryService.errorsMap"
                        [control]="formGroup.controls[consts.COMPANY_NAME]"
                        [fieldConfig]="formFactoryService.fieldConfig(consts.COMPANY_NAME, formConfig)"
                        [context]="formConfig.formKey"
                        [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.COMPANY_NAME)]"
                        (markAsDirty)="markAsDirty($event)"
                >
                </app-text-field>
            </div>

            <div class="section__component col-50"
                 *ngIf="!isNaturalPerson && isFieldVisible(consts.NIP)">
                <app-text-field
                        [errorsMap]="formFactoryService.errorsMap"
                        [control]="formGroup.controls[consts.NIP]"
                        [fieldConfig]="formFactoryService.fieldConfig(consts.NIP, formConfig)"
                        [context]="formConfig.formKey"
                        [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.NIP)]"
                        (markAsDirty)="markAsDirty($event)"
                >
                </app-text-field>
            </div>
        </div>

        <div class="owner-data__children">
            <div class="col" [ngClass]="{'col-preview-mode': previewMode}">
                <div class="section__component"
                     *ngIf="canFieldDisplayed(consts.CHILDREN_UNDER_26)">
                    <app-checkbox *ngIf="!isCarOne"
                                  [errorsMap]="formFactoryService.errorsMap"
                                  [control]="formGroup.controls[consts.CHILDREN_UNDER_26]"
                                  [fieldConfig]="formFactoryService.fieldConfig(consts.CHILDREN_UNDER_26, formConfig)"
                                  [context]="formConfig.formKey"
                                  [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.CHILDREN_UNDER_26)]"
                                  (markAsDirty)="markAsDirty($event)"
                    >
                    </app-checkbox>
                    <app-button-toggle *ngIf="isCarOne"
                                  [errorsMap]="formFactoryService.errorsMap"
                                  [control]="formGroup.controls[consts.CHILDREN_UNDER_26]"
                                  [fieldConfig]="formFactoryService.fieldConfig(consts.CHILDREN_UNDER_26, formConfig)"
                                  [context]="formConfig.formKey"
                                  [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.CHILDREN_UNDER_26)]"
                                  (markAsDirty)="markAsDirty($event)"
                    >
                    </app-button-toggle>
                </div>
            </div>

            <div *ngIf="hasChildrenUnder26" class="col owner-data__children__year-of-birth" [ngClass]="{'col-preview-mode': previewMode}">
                <div class="section__component col-50"
                     *ngIf="canFieldDisplayed(consts.OLDEST_YOUNG_CHILD_YEAR_OF_BIRTH)">
                    <app-material-year-picker
                            [bean]="bean"
                            [errorsMap]="formFactoryService.errorsMap"
                            [control]="formGroup.controls[consts.OLDEST_YOUNG_CHILD_YEAR_OF_BIRTH]"
                            [fieldConfig]="formFactoryService.fieldConfig(consts.OLDEST_YOUNG_CHILD_YEAR_OF_BIRTH, formConfig)"
                            [context]="formConfig.formKey"
                            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.OLDEST_YOUNG_CHILD_YEAR_OF_BIRTH)]"
                            (markAsDirty)="markAsDirty($event)"
                    >
                    </app-material-year-picker>
                </div>
            </div>
        </div>

        <div *ngIf="isFieldVisible(consts.CO_OWNERS)" class="col" [ngClass]="{'col-preview-mode': previewMode}">
            <div class="section__component owner-data__co-owners">
                <app-radio *ngIf="!isNext"
                           [bean]="bean"
                           [errorsMap]="formFactoryService.errorsMap"
                           [control]="formGroup.controls[consts.CO_OWNERS]"
                           [fieldConfig]="formFactoryService.fieldConfig(consts.CO_OWNERS, formConfig)"
                           [context]="formConfig.formKey"
                           [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.CO_OWNERS)]"
                           (markAsDirty)="markAsDirty($event)"
                >
                </app-radio>

                <app-button-toggle *ngIf="isNext"
                                   [bean]="bean"
                           [errorsMap]="formFactoryService.errorsMap"
                           [control]="formGroup.controls[consts.CO_OWNERS]"
                           [fieldConfig]="formFactoryService.fieldConfig(consts.CO_OWNERS, formConfig)"
                           [context]="formConfig.formKey"
                           [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.CO_OWNERS)]"
                           (markAsDirty)="markAsDirty($event)"
                >
                </app-button-toggle>
            </div>
        </div>

        <div *ngIf="coOwnersList && isFieldVisible(consts.CO_OWNERS)" class="owner-data-section__co-owners-list">
            <app-co-owner *ngFor="let coOwner of coOwnersList; let i = index"
                          [isDirtyBean]="isDirtyBean"
                          [index]="i"
                          [coOwner]="coOwner"
                          [coOwnerFormGroup]="coOwnersFormArray.at(i)"
                          [coOwnerFormConfig]="coOwnersFormServices[i].formConfig"
                          [coOwnerFormService]="coOwnersFormServices[i]"
                          [parentSection]="parentSection"
            >
            </app-co-owner>
        </div>

        <div *ngIf="isFieldVisible(consts.ADDITIONAL_DRIVERS)" class="col" [ngClass]="{'col-preview-mode': previewMode}">
            <div class="section__component owner-data__additional-drivers">
                <app-radio *ngIf="!isNext"
                           [bean]="bean"
                           [errorsMap]="formFactoryService.errorsMap"
                           [control]="formGroup.controls[consts.ADDITIONAL_DRIVERS]"
                           [fieldConfig]="formFactoryService.fieldConfig(consts.ADDITIONAL_DRIVERS, formConfig)"
                           [context]="formConfig.formKey"
                           [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.ADDITIONAL_DRIVERS)]"
                           (markAsDirty)="markAsDirty($event)"
                >
                </app-radio>

                <app-button-toggle *ngIf="isNext"
                                   [bean]="bean"
                           [errorsMap]="formFactoryService.errorsMap"
                           [control]="formGroup.controls[consts.ADDITIONAL_DRIVERS]"
                           [fieldConfig]="formFactoryService.fieldConfig(consts.ADDITIONAL_DRIVERS, formConfig)"
                           [context]="formConfig.formKey"
                           [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.ADDITIONAL_DRIVERS)]"
                           (markAsDirty)="markAsDirty($event)"
                >
                </app-button-toggle>
            </div>
        </div>

        <div *ngIf="additionalDriversList && isFieldVisible(consts.ADDITIONAL_DRIVERS)" class="owner-data-section__additional-drivers-list">
            <app-additional-driver *ngFor="let driver of additionalDriversList; let i = index"
                          [bean]="bean.additionalDrivers[i]"
                          [isDirtyBean]="isDirtyBean"
                          [index]="i"
                          [additionalDriver]="driver"
                          [additionalDriverFormGroup]="additionalDriversFormArray.at(i)"
                          [additionalDriverFormConfig]="additionalDriversFormServices[i].formConfig"
                          [additionalDriverFormService]="additionalDriversFormServices[i]"
                          [parentSection]="parentSection"
            >
            </app-additional-driver>
        </div>

        <div *ngIf="previewMode && coOwnersList.length <= 1" class="col add-owner-container" [ngClass]="{'col-preview-mode': previewMode}">
            <button class="btn btn--add" (click)="parentSection.editModeChange()">
                <mat-icon class="btn--add__icon">add</mat-icon>
                <label class="btn--add__label"> {{ 'OWNER_DATA_SECTION.addCoOwnerButtonLabel' | translate }}</label>
            </button>
        </div>
    </ng-template>
</app-section>

<ng-template #drivingLicenseIssueYearTemplate>
    <app-material-year-picker
        #drivingLicenseIssueYearField
        [bean]="bean"
        [errorsMap]="formFactoryService.errorsMap"
        [control]="formGroup.controls[consts.DRIVING_LICENSE_ISSUE_YEAR]"
        [fieldConfig]="formFactoryService.fieldConfig(consts.DRIVING_LICENSE_ISSUE_YEAR, formConfig)"
        [context]="formConfig.formKey"
        [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.DRIVING_LICENSE_ISSUE_YEAR)]"
        (markAsDirty)="markAsDirty($event)"
    >
    </app-material-year-picker>
</ng-template>

<ng-template #drivingLicenseIssueMonthTemplate>
    <app-select
            [errorsMap]="formFactoryService.errorsMap"
            [control]="formGroup.controls[consts.DRIVING_LICENSE_ISSUE_MONTH]"
            [fieldConfig]="formFactoryService.fieldConfig(consts.DRIVING_LICENSE_ISSUE_MONTH, formConfig)"
            [context]="formConfig.formKey"
            [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.DRIVING_LICENSE_ISSUE_MONTH)]"
            (markAsDirty)="markAsDirty($event)"
    >
    </app-select>
</ng-template>
